export default __webpack_public_path__ + "static/media/macbook-mock-dribbble.ae4c2a35.png";